<div class="SLV2-test-instruction-popup">
    <ng-container>
        <h3 class="SLV2-popup-hdng">Let's Revise</h3>
        <div class="SLV2-popup-content-area secondScreen">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/puzzel-animated.gif" class="puzzel" />
        </div>
    </ng-container>
</div>
